module.exports = __webpack_public_path__ + "media/images/print_answer_set/clap-6497ada1be647ea94b817cd95f774717.png";